import { render, staticRenderFns } from "./FieldDropdown.vue?vue&type=template&id=5187bd6c&scoped=true&"
import script from "./FieldDropdown.vue?vue&type=script&lang=js&"
export * from "./FieldDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FieldDropdown.vue?vue&type=style&index=0&id=5187bd6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5187bd6c",
  null
  
)

export default component.exports